import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { Button, Input, InputGroup } from 'components/FormComponents';

import { IntegrationCard } from '../IntegrationCard/IntegrationCard';

export const PageUpIntegration = ({
  config,
  integration,
  updatePartnersConfig = () => {},
  setLoading = () => {},
}) => {
  const [enabled, setEnabled] = useState(integration.enabled);

  const { register, handleSubmit } = useForm({ defaultValues: integration });

  const onSave = async data => {
    setLoading(true);
    await updatePartnersConfig(data);
    setLoading(false);
  };

  useEffect(() => {
    if (enabled || !integration.enabled) return;

    setLoading(true);
    updatePartnersConfig({ page_up_client_id: null }).then(() => {
      setLoading(false);
    });
  }, [enabled]);

  return (
    <IntegrationCard {...config} enabled={enabled} onToggle={e => setEnabled(e.target.checked)}>
      {enabled && (
        <form className="w-full" onSubmit={handleSubmit(onSave)}>
          <InputGroup title="Client Id">
            <Input name="page_up_client_id" register={register} placeholder="Page Up Client ID" />
          </InputGroup>
          <InputGroup title="Client Secret">
            <Input
              name="page_up_client_secret"
              register={register}
              placeholder="Page Up Client Secret"
            />
          </InputGroup>
          <InputGroup title="Instance ID">
            <Input
              name="page_up_instance_id"
              register={register}
              placeholder="Page Up Instance ID"
            />
          </InputGroup>
          <Button type="secondary" submit className="w-full mb-3">
            Save
          </Button>
        </form>
      )}
    </IntegrationCard>
  );
};
